import React from 'react';
import {Card, TextField} from '@mui/material';
import {useFormikContext} from 'formik';

export default function LoanEntryOne() {
  const {values} = useFormikContext();

  const getDisplayValue = (value) => {
    if (!value) return '';
    if (typeof value === 'object') {
      return value?.name || value?.code || '';
    }
    return value;
  };

  return (
    <div>
      <Card className={'box-shadow'} sx={{p: 4, paddingBottom: 5}}>
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Accession No.'}
          value={getDisplayValue(values?.accession_no)}
          disabled
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Ownership'}
          value={getDisplayValue(values?.ownership)}
          disabled
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Classification'}
          value={getDisplayValue(values?.object_group)}
          disabled
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Object Type'}
          value={getDisplayValue(values?.object_type_legacy || values?.object_type)}
          disabled
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Sub Group'}
          value={getDisplayValue(values?.object_sub_group)}
          disabled
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
        <TextField 
          variant={'outlined'} 
          size={'small'} 
          fullWidth 
          label={'Materials'}
          value={getDisplayValue(values?.material)}
          disabled
          sx={{mt: 1.5}}
          InputLabelProps={{
            style: {fontSize: 14, color: '#929191'},
            shrink: true
          }}
        />
      </Card>
    </div>
  );
}